import Head from 'next/head';

const FORCE_NOINDEX = process.env.NEXT_PUBLIC_NOINDEX === 'true';

export default function Yoast({ seo }) {
  if (!seo) {
    return FORCE_NOINDEX ? (
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
    ) : null;
  }

  if (process.env.NEXT_PUBLIC_DEBUG_SEO === 'true') {
    console.log(seo);
  }

  const {
    title,
    description,
    canonical,
    openGraph = {},
    twitter = {},
    noindex,
    nofollow,
  } = seo;

  const robots = [
    noindex || FORCE_NOINDEX ? 'noindex' : null,
    nofollow || FORCE_NOINDEX ? 'nofollow' : null,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <Head>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}

      {openGraph.title && (
        <meta property="og:title" content={openGraph.title} />
      )}
      {openGraph.description && (
        <meta property="og:description" content={openGraph.description} />
      )}
      {openGraph.image?.url && (
        <meta property="og:image" content={openGraph.image.url} />
      )}
      {openGraph.image?.alt && (
        <meta property="og:image:alt" content={openGraph.image.alt} />
      )}

      {twitter.title && <meta name="twitter:title" content={twitter.title} />}
      {twitter.description && (
        <meta name="twitter:description" content={twitter.description} />
      )}
      {twitter.image?.url && (
        <meta name="twitter:image" content={twitter.image.url} />
      )}
      {twitter.image?.alt && (
        <meta name="twitter:image:alt" content={twitter.image.alt} />
      )}

      {robots && <meta name="robots" content={robots} />}
    </Head>
  );
}
